import Carousel from "nuka-carousel";

import { SlideControlButton } from "../SlideControlButton";

import "./styles.css";

export function CarouselComponent({ children }) {
  return (
    <Carousel
      autoplay
      autoplayInterval={10000}
      renderCenterLeftControls={({ previousSlide }) => (
        <SlideControlButton left onClick={previousSlide} />
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <SlideControlButton right onClick={nextSlide} />
      )}
      defaultControlsConfig={{
        pagingDotsClassName: "paging_dots",
      }}
      style={{ marginBottom: "50px" }}
      wrapAround={true}
      dragging={window.innerWidth <= 768}
    >
      {children}
    </Carousel>
  );
}
